import React, { useState } from 'react';
import CONSTANTS from '../../config/constants'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDoubleRight } from '@fortawesome/pro-regular-svg-icons';
import find from 'lodash/find';
import { isLocalHost } from "../../../core/helpers/CoreHelpers";

const ContactsBlock = (props) => {
    const [contacts, setContacts] = useState([]);
    const [loading, setLoading] = useState(true);
    const { contentFields, width } = props;

    const getContentFieldValue = (fieldDefinitionKey) => {
        const data = find(contentFields, { fieldDefinitionKey });

        if (data) {
            try {
                return JSON.parse(data.data);
            } catch (e) {
                return data.data;
            }
        }

        return false;
    };

    const getBlockWidth = () => {
        let w = 40;

        if (width && width !== CONSTANTS.BLOCK_DEFAULT_WIDTH) {
            return width;
        } else {
            const widthValue = getContentFieldValue('Width');
            if (widthValue && widthValue !== CONSTANTS.BLOCK_DEFAULT_WIDTH && widthValue !== w) {
                w = widthValue;
            }
        }

        return w;
    };

    const getContactList = (e) => {
        const { target: { contentDocument, contentWindow } } = e;
        const contacts = [];
        const iframeContent = contentDocument ? contentDocument : contentWindow.document;

        if (iframeContent) {
            iframeContent.querySelectorAll('.cr-page-content [ct="PaddingContainer"] .c-hrepeater-item').forEach((item) => {
                const connectionData = item.querySelectorAll('td');

                if (connectionData.length === 0) {
                    return;
                }

                if (contacts.length < 3) {
                    contacts.push({
                        picture: connectionData[0].querySelector("img").getAttribute("src"),
                        name: connectionData[1].querySelector("a").innerHTML,
                        profileUrl: connectionData[1].querySelector("a").getAttribute("href"),
                        workTitle: connectionData[1].querySelector("span").getAttribute("title")
                    });
                }
            });
        }

        setContacts(Array.from(contacts));
        setLoading(false);
    };

    const data = {
        title: getContentFieldValue('Title'),
        contacts: contacts,
        link: 'All contacts',
        url: '/phnx/driver.aspx?routename=Social/UniversalProfile/AllConnections',
        loading: loading
    };

    return (
        <section
            className={"contacts-block w--" + getBlockWidth() + " show--shadow"}>
            <div className="title-section">
                <h3>{data.title}</h3>
            </div>
            <div className="content">
                <ul>
                    {!data.loading && data.contacts.map((contact, key) => (
                        <li key={key}>
                            <a href={contact.profileUrl}>
                                <figure>
                                    <img style={{ borderRadius: '50%' }} src={contact.picture}
                                        alt={contact.name} />
                                </figure>
                                <div className="contact-content">
                                    <em>{contact.name}, <span>{contact.workTitle}</span></em>
                                </div>
                            </a>
                        </li>
                    ))}
                </ul>
                <a href={data.url}>
                    {data.link}
                    <FontAwesomeIcon icon={faChevronDoubleRight} />
                </a>
            </div>
            {!isLocalHost() &&
                <iframe
                    style={{ display: "none" }}
                    title={'CSOD Contacts'}
                    src="/phnx/driver.aspx?routename=Social/UniversalProfile/AllConnections"
                    onLoad={getContactList}
                />
            }

        </section>
    );
};

export default ContactsBlock;



// WEBPACK FOOTER //
// ./src/frontend/components/Blocks/ContactsBlock.js